module.exports = __webpack_public_path__ + "img/circle-user.8903f5d6.svg";